import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdOnboardingsByOnboardingIdTraceQueryKey } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import { IcoWarning16 } from '@onefootprint/icons';
import { Dropdown, useConfirmationDialog, useToast } from '@onefootprint/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import useSession from '@/hooks/use-session';
import errorWorkflows from '../error-workflows';
type ErrorWorkflowItemProps = {
  fpId: string;
  onboardingId: string;
};
const ErrorWorkflowItem = t0 => {
  const $ = _c(23);
  const {
    fpId,
    onboardingId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardingTraceDialog.errorWorkflow"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    authHeaders
  } = useSession();
  const {
    toast
  } = useToast();
  const showErrorToast = useRequestErrorToast();
  const confirm = useConfirmationDialog();
  const queryClient = useQueryClient();
  let t2;
  if ($[1] !== authHeaders || $[2] !== onboardingId) {
    t2 = () => errorWorkflows(authHeaders, [onboardingId]);
    $[1] = authHeaders;
    $[2] = onboardingId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== fpId || $[5] !== onboardingId || $[6] !== queryClient || $[7] !== t || $[8] !== toast) {
    t3 = () => {
      toast({
        title: t(_temp),
        description: t(_temp2)
      });
      queryClient.invalidateQueries({
        queryKey: getEntitiesByFpIdOnboardingsByOnboardingIdTraceQueryKey({
          path: {
            fpId,
            onboardingId
          }
        })
      });
    };
    $[4] = fpId;
    $[5] = onboardingId;
    $[6] = queryClient;
    $[7] = t;
    $[8] = toast;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== showErrorToast || $[11] !== t2 || $[12] !== t3) {
    t4 = {
      mutationFn: t2,
      onSuccess: t3,
      onError: showErrorToast
    };
    $[10] = showErrorToast;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const mutation = useMutation(t4);
  let t5;
  if ($[14] !== confirm || $[15] !== mutation || $[16] !== t) {
    t5 = () => {
      confirm.open({
        title: t(_temp3),
        description: t(_temp4),
        primaryButton: {
          label: t(_temp5),
          onClick: () => mutation.mutate(undefined)
        },
        secondaryButton: {
          label: t(_temp6)
        }
      });
    };
    $[14] = confirm;
    $[15] = mutation;
    $[16] = t;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const handleSelect = t5;
  let t6;
  if ($[18] !== t) {
    t6 = t(_temp7);
    $[18] = t;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== handleSelect || $[21] !== t6) {
    t7 = <Dropdown.Item iconLeft={IcoWarning16} onSelect={handleSelect}>{t6}</Dropdown.Item>;
    $[20] = handleSelect;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export default ErrorWorkflowItem;
function _temp($) {
  return $.toast.title;
}
function _temp2($_0) {
  return $_0.toast.description;
}
function _temp3($_1) {
  return $_1.confirm.title;
}
function _temp4($_2) {
  return $_2.confirm.description;
}
function _temp5($_3) {
  return $_3.confirm.cta;
}
function _temp6($_4) {
  return $_4.confirm.cancel;
}
function _temp7($_5) {
  return $_5.label;
}